module.exports = __webpack_public_path__ + "img/ticket_hover_9d2f642.png";